import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/layout/Layout";
import LandingPage from "./pages/Landing";
import RouteChangeTracker from "./components/shared/analytics/RouteChangeTracker";

const App = () => {
  return (
    <>
      {/* The tracker will now listen for route changes */}
      <RouteChangeTracker />

      <Routes>
        <Route element={<Layout />}>
          <Route path="/" element={<LandingPage />} />
        </Route>
      </Routes>
    </>
  );
};

export default App;
